import { useCallback } from 'react';
import { useField } from 'formik';

import { useProducts } from 'contexts/Products';
import VirtualPackField from 'fields/VirtualPackField';

export default function VirtualPack({ disabled }: { disabled?: boolean }) {
  const [, , { setValue }] = useField('productData');

  const {
    state,
    selectors: { selectVirtualPack },
  } = useProducts();

  const handleChange = useCallback(
    (value) => {
      setValue(selectVirtualPack(state.virtualPacks, value) || {});
    },
    [state, setValue, selectVirtualPack],
  );

  return (
    <VirtualPackField
      name="packagedItemReference"
      disabled={disabled}
      onChange={handleChange}
      textFieldProps={{
        required: true,
      }}
    />
  );
}
